import React from "react";
import { Tabs, Tab, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import { INTERVIEW_LIST_TAB_DIMENSIONS } from "../../utils/constants";
import { baseAtom, setInsightSelection, setSelectedArtifactType } from "../../../../stores/jotai/base";



const TableHeader = ({ isAnalysisAvailable }) => {
  const [base, setBase] = useAtom(baseAtom);
  const theme = useTheme();
  const tabIndex = base.selectedArtifactType.includes("notes") ? 0 : 1;

  return (
    <Tabs
      className="Interview-Documents-Tab"
      sx={{
        minHeight: `${INTERVIEW_LIST_TAB_DIMENSIONS.MIN_HEIGHT}px + 5px`,
        height: `${INTERVIEW_LIST_TAB_DIMENSIONS.HEIGHT}px`,
        borderBottom: `1px solid ${theme.custom.borderGrey}`,
        ".MuiTab-root": {
          textTransform: "capitalize",
          padding: "23px 16px",
          height: `${INTERVIEW_LIST_TAB_DIMENSIONS.HEIGHT}px`,
          minHeight: `${INTERVIEW_LIST_TAB_DIMENSIONS.MIN_HEIGHT}px`,
          fontSize: "1rem",
          "&:hover": {
            color: "#1976D2",
            borderBottom: "2px solid #1976D2",
          },
        },
        ".Mui-selected": {
          "&:hover": {
            fontWeight: "700 !important",
          },
        },
      }}
      value={tabIndex}
      onChange={(e, t) => {
        setBase((prev) => ({
          ...prev,
          selectedFinding: undefined,
        }));
        if (t === 0) {
          setSelectedArtifactType(setBase, "notes");
          setInsightSelection(setBase, undefined);
        } else {
          setSelectedArtifactType(setBase, "metaanalysis");
          setInsightSelection(setBase, undefined);
        }
      }}
    >
      <Tab label="Notes" />
      {base.team?.isAiInsightGenerationEnabled && (
        <Tab label="Analysis" disabled={!isAnalysisAvailable} />
      )}
    </Tabs>
  );
};

export default TableHeader;
